import { Button, useDeviceType } from '@cian/ui-kit';
import React from 'react';
import cn from 'classnames';

import { NBSP } from '../../constants/symbols';
import { IPriceData } from '../../types/priceData';

import * as styles from './styles.css';

export const PriceCard: React.FC<{
  priceData: IPriceData;
  priceListUrl: string;
  onCreateDealButtonClick(): void;
}> = props => {
  const deviceType = useDeviceType();
  const { priceData, priceListUrl } = props;

  return (
    <div className={cn(styles['price-card'], styles[deviceType])}>
      <div className={styles['price']} aria-label="Цена">
        <span>
          от <span className={styles['initial-price']}>{priceData.initialPrice}</span>
        </span>
        <span>+ госпошлина</span>
        {priceData.fullPrice && (
          <span className={styles['full-price']}>
            Общая сумма услуги —{NBSP}
            <a
              data-testid="price-list-link"
              className={styles['price-list-link']}
              href={priceListUrl}
              target="_blank"
              rel="noreferrer"
            >
              {priceData.fullPrice}
            </a>
          </span>
        )}
      </div>
      <div className={styles['create-deal-button']}>
        <Button onClick={props.onCreateDealButtonClick} fullWidth size="L" data-testid="pricingCreateDealButton">
          Провести сделку
        </Button>
      </div>
    </div>
  );
};
